import {nextTick} from "vue";
import {useStore} from "vue2-helpers/vuex";

export default function () {
    const store = useStore();

    return function (mutation) {
        store.commit(mutation, true);

        nextTick(() => {
            store.commit(mutation, false);
        })
    };
}
